import Dialog13 from './QC13';
import Dialog14 from './QC14';
import Dialog15 from './QC15';
import Dialog16 from './QC16';
import Dialog19 from './QC19';
import Dialog20 from './QC20';
import Dialog21 from './QC21';
import Dialog22 from './QC22';
import Dialog23 from './QC23';
import Dialog24 from './QC24';
import Dialog25 from './QC25';
import Dialog26 from './QC26';
import Dialog27 from './QC27';
import Dialog28 from './QC28';
import Dialog37 from './QC37';
import Dialog38 from './QC38';

// 不用了
// import Dialog33 from './QC33';

import Dialog34 from './QC34';
import Dialog35 from './QC35';
import Dialog36 from './QC36';
import Bus from '@/utils/bus';

const components = {
  d13: Dialog13,
  d14: Dialog14,
  d15: Dialog15,
  d16: Dialog16,
  d19: Dialog19,
  d20: Dialog20,
  d21: Dialog21,
  d22: Dialog22,
  d23: Dialog23,
  d24: Dialog24,
  d25: Dialog25,
  d26: Dialog26,
  d27: Dialog27,
  d28: Dialog28,
  // d33: Dialog33,

  d34: Dialog34,
  d35: Dialog35,
  d36: Dialog36,
  d37: Dialog37,
  d38: Dialog38,
};

export default {

  install(Vue) {
    const instance = [];
    const MessageBox = {};

    const body = document.body || document.documentElement;
    const root = document.createElement('div');
    root.id = 'messageBox';

    Bus.$on('changeTheme', function (nval) {
      root.className = 'theme-' + nval;
    });
    body.appendChild(root);

    const initComponents = function (type, options) {


      options = Object.assign({
        title: '弹窗标题',
        params: {}
      }, options);

      type = type || '';

      // 组件定义了
      if (components[type]) {

        if (!instance[type]) {
          const MessageBox = Vue.extend(components[type]);
          const div = document.createElement('div');
          root.appendChild(div);

          instance[type] = new MessageBox({
            el: div
          });
        }

        const ins = instance[type];

        for (let i in options) {
          ins[i] = options[i];
        }

        Vue.nextTick(() => {
          ins.show();
          ins.loadInfo && ins.loadInfo();
          ins.loadAccountLog && ins.loadAccountLog();
        });

        return new Promise((resolve, reject) => {
          ins._promise = {
            resolve,
            reject
          }
        }).finally(() => {

        })
      } else {
        return Promise.reject('组件不存在');
      }
    };

    // 参数 type = '', options = {}
    MessageBox.show = initComponents;

    MessageBox.hide = function (type) {
      instance[type].hide();
    };

    Vue.prototype.$MessageBox = MessageBox;
  }

}



// WEBPACK FOOTER //
// ./src/components/dialog/plugin.js